<template>
  <div class="lime-body">
   <div class="container">
      <div class="row">
         <div class="col-md-12">
         <flash-message  id="flash-message" ></flash-message>
            <nav aria-label="breadcrumb">
               <ol class="breadcrumb breadcrumb-separator-1">
                  <!--<li class="breadcrumb-item"><a href="#">Pages</a></li>-->
                  <li class="breadcrumb-item active" aria-current="page">Users List</li>
               </ol>
            </nav>
            <div class="page-title">
               <h3>Users List</h3>
               <div class="search-create">
                <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
                  <div class="search">
                    <input class="form-control mr-sm-2"  v-model="filter" @keydown="$event.stopImmediatePropagation()" type="text" placeholder="Search User" aria-label="Search" />
                  </div>
                  <button class="btn btn-primary" id="userBtn" v-on:click="adUser()"><i class="material-icons">add</i> Add User</button>
               </div>
            </div>
         </div>
      </div>
      <div class="row">
         <div class="col-md-12">
            <div class="table-responsive">
              <datatable :class="tblCls" :columns="columns" :filter="filter" :per-page="10" :data="usersList"></datatable>   
              <datatable-pager v-model="page" class="pagination"></datatable-pager>
            </div>
         </div>
      </div>

   </div>
</div>
</template>
<script>
  import axios from 'axios'
  import AddUser from './AddUser'
  import Action from './Action'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  require('vue-flash-message/dist/vue-flash-message.min.css')
  export default {
    name: 'User',
    props: ['rows'],
    components: { AddUser,
      Loading
    },
    data () {
      return {
        isLoading: false,
        fullPage: true,
        errorMessage: '',
        tblCls: 'table',
        users: [],
        usersList: [],
        errors: [],
        i: 1,
        input: {
          email: '',
          name: '',
          username: '',
          userrole: '',
          password: '',
          cnfpassword: ''
        },
        columns: [
          {label: 'Stripe CustomerID', field: 'id'},
          {label: 'Name', field: 'name', headerClass: 'class-in-header second-class'},
          {label: 'User Name', field: 'username'},
          {label: 'Email', field: 'email'},
          {label: 'Role', field: 'role'},
          {label: 'User Type', field: 'usertype'},
          {label: 'Status', field: 'status'},
          {label: 'Action',
            component: Action,
            sortable: false
          }
        ],
        rows: this.usersList,
        filter: '',
        page: 1
      }
    },
    methods: {
      adUser () {
       this.$modal.show(AddUser, { height: '100%' })
      },
   
    getAlluser () { 
      let jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
        this.usersList = [];
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllUsers', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.users = response.data.results
          for (var i in this.users) {
            var obj = this.users[i]
            var name = ''
            if(obj.firstname && !obj.lastname) {
              name = obj.firstname
            } else if (obj.firstname && obj.lastname) {
              name = obj.firstname + " " + obj.lastname
            } else if (obj.name) {
              name = obj.name
            }
            
            this.usersList.push({
              id: obj.stripe_customer_id,
              name: name,
              uid: obj.uid,
              username: obj.username,
              email: obj.email,
              role: obj.role,
              usertype:obj.user_type,
              status: obj.status,
              stripe_subscription_id: obj.stripe_subscription_id
            })
          }
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })

      }
    },
    created () {
    },
    mounted () {
      this.$eventBus.$on('listUser', (data,error) => { 
          const messageStorage = this.flash();
          if (data) {  
             this.getAlluser() ;
             this.$forceUpdate();
             messageStorage.destroyAll()
             this.flash(data, 'success', {timeout: 3000 });
          }
          else if (error) { 
          this.flash(error, 'error', {timeout: 3000 });
          }
      }) 
    this.getAlluser()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/User.vue